import { render, staticRenderFns } from "./FeedbackDropdownItem.vue?vue&type=template&id=6afcf174&%23list=true"
import script from "./FeedbackDropdownItem.vue?vue&type=script&lang=js"
export * from "./FeedbackDropdownItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports